module.exports = __webpack_public_path__ + "img/LIC.4149f1d0.png";